import * as React from "react";
import { Button } from "@react-email/button";
import {
  Img,
  Heading,
  Row,
  Section,
  Column,
  Container,
  Link,
  Html,
} from "@react-email/components";
import { Text } from "@react-email/text";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Layout from "../components/Layout";
import { Markdown } from "@react-email/markdown";

export const name = "WaitlistSellOrderFilled";
export const subject = "Your tickets: {{event_name}}";

const RoundedContainer = ({
  children,
  style = {},
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <Container
      style={{
        borderRadius: "4px",
        marginBottom: "16px",
        border: `1px solid #333`,
        padding: "16px",
        ...style,
      }}
    >
      {children}
    </Container>
  );
};

export function template({
  event_name,
  event_url,
  organization_logo,
  event_image,
  wallet_url,
  cdn_url,
  display_start_at,
  ticket_type_name,
  full_name,
  total_price_display,
  quantity,
  event_description,
  faq_link,
  venue_name,
  venue_address,
}: {
  event_name: string;
  event_url: string;
  organization_logo: string;
  event_image: string;
  wallet_url: string;
  cdn_url: string;
  display_start_at: string;
  ticket_type_name: string;
  full_name: string;
  total_price_display: string;
  quantity: string;
  event_description: string;
  faq_link: string;
  venue_name: string;
  venue_address: string;
}) {
  return (
    <Layout language="en" title={event_name}>
      <Header src={`${cdn_url}/system/kyd-logo-email.png`} />
      <Container>
        <Heading as="h1" style={title}>
          We found a buyer for your tickets!
        </Heading>
      </Container>
      <RoundedContainer>
        <Link href={event_url}>
          <Img
            width={"100%"}
            style={{ marginTop: "8px", borderRadius: "4px" }}
            src={event_image}
          />
        </Link>

        <Section width={"100%"}>
          <Row>
            <Heading as="h2" style={eventName}>
              {event_name}
            </Heading>
          </Row>
          <Row style={{ marginTop: "16px", marginBottom: "16px" }}>
            <Column style={{ textAlign: "center" }}>
              <Button
                href={wallet_url}
                style={{
                  backgroundColor: "black",
                  borderRadius: "45px",
                  fontWeight: "bold",
                  padding: "15px 20px",
                  color: "white",
                  fontSize: "14px",
                  margin: "0 auto",
                  border: "1px solid white",
                  cursor: "pointer",
                  minWidth: "200px",
                }}
              >
                VIEW REMAINING TICKETS
              </Button>
            </Column>
          </Row>
        </Section>
      </RoundedContainer>
      <RoundedContainer>
        <Text style={style.cardTitle}>Refund details</Text>
        <Section
          style={{
            marginTop: "8px",
            borderTop: "1px solid #333",
            color: "white",
            fontSize: "12px",
            padding: "8px",
            paddingTop: "16px",
          }}
        >
          <Row
            style={{
              width: "100%",
              alignItems: "flex-start",
              verticalAlign: "top",
              paddingBottom: "16px",
              borderBottom: "1px solid #333",
            }}
          >
            <Column
              width={"50%"}
              style={{ verticalAlign: "top", color: "#666" }}
            >
              Venue
            </Column>
            <Column width={"50%"} align="right" style={style.rowValue}>
              <Row>
                <Column align="right">{venue_name}</Column>
              </Row>
              <Row style={{ marginTop: "16px" }}>
                <Column align="right">{venue_address}</Column>
              </Row>
            </Column>
          </Row>
          <Row
            style={{
              width: "100%",
              alignItems: "flex-start",
              verticalAlign: "top",
              paddingBottom: "16px",
              paddingTop: "16px",
              borderBottom: "1px solid #333",
            }}
          >
            <Column width={"30%"} style={style.rowLabel}>
              Date & time
            </Column>
            <Column width="80%" align="right" style={style.rowValue}>
              {display_start_at}
            </Column>
          </Row>
          <Row
            style={{
              width: "100%",
              alignItems: "flex-start",
              verticalAlign: "top",
              paddingBottom: "16px",
              paddingTop: "16px",
              borderBottom: "1px solid #333",
            }}
          >
            <Column width={"30%"} style={style.rowLabel}>
              Ticket Type
            </Column>
            <Column width="80%" align="right" style={style.rowValue}>
              {ticket_type_name}
            </Column>
          </Row>
          <Row
            style={{
              width: "100%",
              alignItems: "flex-start",
              verticalAlign: "top",
              paddingBottom: "16px",
              paddingTop: "16px",
              borderBottom: "1px solid #333",
            }}
          >
            <Column width={"30%"} style={style.rowLabel}>
              Quantity
            </Column>
            <Column width="80%" align="right" style={style.rowValue}>
              {quantity}
            </Column>
          </Row>
          <Row
            style={{
              width: "100%",
              alignItems: "flex-start",
              verticalAlign: "top",
              paddingBottom: "16px",
              paddingTop: "16px",
              borderBottom: "1px solid #333",
            }}
          >
            <Column width={"30%"} style={style.rowLabel}>
              Name on ticket
            </Column>
            <Column width="80%" align="right" style={style.rowValue}>
              {full_name}
            </Column>
          </Row>
          <Row
            style={{
              width: "100%",
              alignItems: "flex-start",
              verticalAlign: "top",
              paddingBottom: "16px",
              paddingTop: "16px",
            }}
          >
            <Column width={"30%"} style={style.rowLabel}>
              Refund
            </Column>
            <Column width="80%" align="right" style={style.rowValue}>
              {total_price_display}
            </Column>
          </Row>
          <Row
            style={{
              width: "100%",
              alignItems: "flex-start",
              verticalAlign: "top",
              paddingBottom: "16px",
              paddingTop: "16px",
            }}
          >
            <Column width="100%" align="center" style={style.rowValue}>
              Your refund will be processed in 5 - 7 business days
            </Column>
          </Row>
        </Section>
      </RoundedContainer>
      <RoundedContainer>
        <Text style={style.cardTitle}>Event information</Text>
        <Section
          style={{
            marginTop: "8px",
            borderTop: "1px solid #333",
            color: "white",
            fontSize: "12px",
            padding: "8px",
            paddingTop: "16px",
          }}
        >
          <Markdown
            markdownCustomStyles={{
              h1: { color: "black" },
              h2: { color: "black" },
              h3: { color: "black" },
              p: { color: "black" },
              codeInline: { background: "black" },
            }}
          >
            {event_description}
          </Markdown>
        </Section>
      </RoundedContainer>
      <RoundedContainer
        style={{
          backgroundColor: "#fff",
        }}
      >
        <Text style={style.cardTitle}>Need help?</Text>
        <Section
          style={{
            marginTop: "8px",
            borderTop: "1px solid #333",
            color: "black",
            fontSize: "12px",
            padding: "8px",
            paddingTop: "16px",
          }}
        >
          <Text style={style.eventDescription}>
            Check out our <Link href={faq_link}>FAQ</Link>. For anything urgent,
            reply to this email.
          </Text>
        </Section>
      </RoundedContainer>
      <Footer cdn_url={cdn_url} />
    </Layout>
  );
}

const bodyText = {
  fontSize: "18px",
  lineHeight: "22px",
};

const style: Record<string, React.CSSProperties> = {
  cardTitle: {
    color: "black",
    margin: 0,
    fontSize: "14px",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  rowLabel: {
    verticalAlign: "top",
    color: "black",
  },
  rowValue: {
    fontWeight: "500",
    color: "black",
  },
  eventDescription: {
    fontSize: "12px",
    color: "black",
    lineHeight: "18px",
    margin: 0,
  },
};

const helpText = {
  fontSize: "12px",
  margin: 0,
  lineHeight: "18px",
  marginBottom: "8px",
};

const centeredHelpText: React.CSSProperties = {
  ...helpText,
  textAlign: "center",
};

const title = {
  fontSize: "30px",
  fontWeight: 500,
  color: "black",
};

const eventName: React.CSSProperties = {
  ...title,
  textTransform: "uppercase",
};

const label = {
  ...title,
  fontSize: "18px",
  color: "#808080",
  fontWeight: "normal",
};

const subtitle = {
  ...title,
  color: "#808080",
  fontSize: "26px",
};

template.PreviewProps = {
  event_name: "Test event",
  event_url: "/static/coachella.jpg",
  start_at: new Date().toISOString(),
  ticket_type_name: "Table seat",
  quantity: "4",
  user_name: `David Barrick`,
  total_price_display: "$185.38",
  wallet_url: "https://google.com",
  venue_name: "LPR",
  venue_address: "55 N 5th St",
  event_description: `Test **description** 23456 Here's a link to support: [https://help.kydlabs.com](https://help.kydlabs.com)`,
  faq_link: "https://help.kydlabs.com",
  event_image: "",
  cdn_url: "",
  display_start_at: "",
  full_name: "",
  organization_logo: "",
};

export default template;
